var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContracts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-V4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---Documents",
    fill: "#1B1C1F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,0 C30.209139,0 32,1.790861 32,4 L32,28 C32,30.209139 30.209139,32 28,32 L4,32 C1.790861,32 0,30.209139 0,28 L0,4 C0,1.790861 1.790861,0 4,0 L28,0 Z M28,2 L4,2 C2.9456382,2 2.08183488,2.81587779 2.00548574,3.85073766 L2,4 L2,28 C2,29.0543618 2.81587779,29.9181651 3.85073766,29.9945143 L4,30 L28,30 C29.0543618,30 29.9181651,29.1841222 29.9945143,28.1492623 L30,28 L30,4 C30,2.9456382 29.1841222,2.08183488 28.1492623,2.00548574 L28,2 Z M17.4,21 C17.7313708,21 18,21.4477153 18,22 C18,22.5128358 17.7683759,22.9355072 17.4699727,22.9932723 L17.4,23 L6.6,23 C6.26862915,23 6,22.5522847 6,22 C6,21.4871642 6.23162411,21.0644928 6.53002732,21.0067277 L6.6,21 L17.4,21 Z M17.4,15 C17.7313708,15 18,15.4477153 18,16 C18,16.5128358 17.7683759,16.9355072 17.4699727,16.9932723 L17.4,17 L6.6,17 C6.26862915,17 6,16.5522847 6,16 C6,15.4871642 6.23162411,15.0644928 6.53002732,15.0067277 L6.6,15 L17.4,15 Z M17.4,9 C17.7313708,9 18,9.44771525 18,10 C18,10.5128358 17.7683759,10.9355072 17.4699727,10.9932723 L17.4,11 L6.6,11 C6.26862915,11 6,10.5522847 6,10 C6,9.48716416 6.23162411,9.06449284 6.53002732,9.00672773 L6.6,9 L17.4,9 Z M27,9 L27,24.8099652 C27,25.032815 26.925562,25.2492795 26.7885023,25.424997 L24.7885023,27.9890996 C24.4488296,28.4245774 23.820446,28.5022428 23.3849682,28.1625701 C23.3202442,28.1120854 23.2619824,28.0538236 23.2114977,27.9890996 L21.2114977,25.424997 C21.074438,25.2492795 21,25.032815 21,24.8099652 L21,9 L27,9 Z M25,11 L23,11 L23,24.467 L24,25.749 L25,24.466 L25,11 Z M25,4 C26.1045695,4 27,4.8954305 27,6 L27,11 L21,11 L21,6 C21,4.8954305 21.8954305,4 23,4 L25,4 Z M25,6 L23,6 L23,9 L25,9 L25,6 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContracts);
export default __webpack_public_path__ + "static/media/contracts.781bdba592655d5ea203ef25fe234981.svg";
export { ForwardRef as ReactComponent };